import React from 'react';
import ReactDOM from "react-dom";
import UI from './components/UI.jsx';
import "./css/index.scss";

export default class Handler {

    constructor() {
        APP.uiHandler = this;
        this.window = window;
        ReactDOM.render(
            <UI handler={this}/>,
            document.getElementById('cfg')
        );

    }

    updateFromArrangement() {
        this.ui.updateFromArrangement()
    }

    dialog(options) {
        this.ui.showModal(options)
    }
    
    showHelpPopup(product) {
        APP.uiHandler.dialog({
            title: product.Anzeigename,
            text: product.Beschreibung,
            thumbnail: product.Bild,
            buttons: [
                {
                    style: 'primary', label: I18N('OK')
                }
            ]
        });
    }

    sidebar(type, context) {
        APP.model.currentContext = context;
        this.ui.showSidebar(type);
    }
}